export default __webpack_public_path__ + "caa8fe901fafe7afc35ae6798c83cc8a.svg";